import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { CommonModule } from '@angular/common';
import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';
import { SavedTagsComponent } from './saved-tags/saved-tags.component';

import { ApiService } from './shared/services/api.service';
import { TagService } from './shared/services/tag.service';
import { CourseService } from './shared/services/course.service';

import { SharedModule } from './shared/shared.module';
import { TagModule } from './tag/tag.module';
import { SplashModule } from './splash/splash.module';
import { CoursesModule } from './courses/courses.module';
import { CourseDetailModule } from './course-detail/course-detail.module';

@NgModule({
    declarations: [
        AppComponent,
        SavedTagsComponent
    ],
    imports: [
        CommonModule,
        BrowserModule,
        FormsModule,
        HttpModule,
        AppRoutingModule,
        SharedModule,
        SplashModule,
        TagModule,
        CoursesModule,
        CourseDetailModule
    ],
    providers: [
        ApiService,
        TagService,
        CourseService
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// C:/dev/um.stamps/src/app/app.module.ts